import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu", "label"]

  connect() {
    // Close dropdown when clicking outside
    this.clickOutsideHandler = (event) => {
      if (!this.element.contains(event.target)) {
        this.close()
      }
    }
    document.addEventListener('click', this.clickOutsideHandler)
  }

  disconnect() {
    document.removeEventListener('click', this.clickOutsideHandler)
  }

  toggle(event) {
    event.stopPropagation()
    const isVisible = this.menuTarget.style.display !== 'none'
    this.menuTarget.style.display = isVisible ? 'none' : 'block'
  }

  close() {
    this.menuTarget.style.display = 'none'
  }

  update() {
    // Update the label to show selected count
    const activityChecked = this.element.querySelectorAll('input[name="activity_status[]"]:checked')
    const botChecked = this.element.querySelectorAll('input[name="bot_status[]"]:checked')
    const staleChecked = this.element.querySelector('input[name="stale"]:checked')
    const total = activityChecked.length + botChecked.length + (staleChecked ? 1 : 0)

    if (total === 0) {
      this.labelTarget.textContent = 'All'
    } else {
      this.labelTarget.textContent = `${total} selected`
    }
  }

  clear() {
    this.element.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false)
    this.labelTarget.textContent = 'All'
  }

  apply() {
    const activityStatuses = Array.from(this.element.querySelectorAll('input[name="activity_status[]"]:checked')).map(cb => cb.value)
    const botStatuses = Array.from(this.element.querySelectorAll('input[name="bot_status[]"]:checked')).map(cb => cb.value)
    const staleChecked = this.element.querySelector('input[name="stale"]:checked')

    const url = new URL(window.location.href)

    // Clear existing params
    url.searchParams.delete('activity_status[]')
    url.searchParams.delete('bot_status[]')
    url.searchParams.delete('stale')
    url.searchParams.delete('page')

    // Add new params
    activityStatuses.forEach(status => url.searchParams.append('activity_status[]', status))
    botStatuses.forEach(status => url.searchParams.append('bot_status[]', status))
    if (staleChecked) url.searchParams.set('stale', 'true')

    window.location.href = url.toString()
  }
}
